
import { type FC, memo, useMemo } from 'react';

import { FAVORITE_SECTION_NAME } from '@repo/common';
import { LOBBY_SECTION_NAME } from '../../../constants';
import { getSectionIconBaseName } from '../../utils/sectionIcon';
import Image from '../Image';

interface SectionIconProps {
  sectionName: string;
  isActive: boolean;
  isIngame?: boolean;
}

// PERFORMANCE OPTIMIZED: Memoized icon component with cached paths and styles
const SectionIcon: FC<SectionIconProps> = ({ sectionName, isActive, isIngame = false }) => {
  // Memoized icon path calculation
  const iconPath = useMemo(() => {
    let pathToReturn;
    if (sectionName !== LOBBY_SECTION_NAME) {
      const baseName = getSectionIconBaseName(sectionName);
      const iconName = `${baseName}_icon${isIngame && sectionName !== FAVORITE_SECTION_NAME ? '_ingame' : ''}`;

      pathToReturn = `/icons/${iconName}`;
    }
    else {
      pathToReturn = `/ui/EGTD_only_logo`;
    }

    return pathToReturn;
  }, [sectionName]);

  // Memoized style object for active/inactive states. The filter lives in GlobalStyles
  // (--filter-active-icon) so a seasonal palette can recolour the active icon.
  const iconStyle = useMemo(() => ({
    filter: isActive && sectionName !== LOBBY_SECTION_NAME
      ? 'var(--filter-active-icon)'
      : 'none'
  }), [isActive]);

  return (
    <Image
      src={iconPath}
      manualAffix=".svg"
      alt={`${sectionName} icon`}
      style={iconStyle}
    />
  );
};

export default memo(SectionIcon);
